import React from 'react';

export default function TheCatch({ lang }) {
  return (
    <section className="w-full py-12 mt-8">
      <div className="bg-red-600 text-white p-6 sm:p-8 border-4 border-white">
        <h2 className="text-4xl sm:text-5xl font-black uppercase mb-4 flex items-center gap-3">
          <span className="text-black bg-white px-2">!</span>
          {lang === 'en' ? 'The Catch' : 'La Trampa'}
        </h2>
        
        <p className="text-2xl sm:text-3xl font-bold uppercase leading-tight">
          {lang === 'en' 
            ? 'We are only selling 100 passes total. Once they are gone, they are gone forever.' 
            : 'Solo estamos vendiendo 100 pases en total. Una vez que se agoten, se van para siempre.'}
        </p>
        
        <div className="mt-8 flex justify-center">
          <div className="inline-block border-4 border-black bg-white text-black font-black text-4xl sm:text-6xl px-6 py-4 animate-pulse">
            {lang === 'en' ? '100 ONLY' : 'SOLO 100'}
          </div>
        </div>
      </div>
    </section>
  );
}